import { useState } from "react";
import { ToastContainer, toast } from 'react-toastify';

import { useEffect } from "react";
import loading from "../../assets/images/loading.gif"
import status from "../../assets/images/total-icon.png"
import number from "../../assets/images/number-icon.png"
import date from "../../assets/images/date-icon.png"
import person from "../../assets/images/user-icon.png"
import {POLineItems, PurchaseOrderInfo } from "../../interfaces/purchaseorder.types";
import { useDispatch, useSelector } from "react-redux";
import { makeGetRequest } from "../../request";
import { customStyles, formatCurrency, formatDateTime, getCurrencySymbol } from "../../helpers";
import Modal from "react-modal"
import { useParams, useNavigate, useLocation } from "react-router-dom";
import Pagination from "../../components/Pagination";
import Layout from "../Layout";
import { setPageContext } from "../../store/pageContext";

const PurchaseOrder =  () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const location = useLocation()
    const param = useParams()
    const user: any = useSelector((state: any)=> state.tepngUser.value)
    const pageContext: any = useSelector((state: any)=> state.pageContext.value)
    const [purchaseOrder, setRecords] = useState<PurchaseOrderInfo| null>()
    const [poLineItems, setPoLineItems] = useState<POLineItems[]>()
    const statusBeforeNavigation = location.state as { originName: string };
    
    // For Purchase Order Items
    const [currentPage1, setCurrentPage1] = useState(1);
    const [itemsPerPage1, setItemsPerPage1] = useState(25);
    const [totalItems1, setTotalItems1] = useState(0);
    const totalPages1 = Math.ceil(totalItems1 / itemsPerPage1);

    const [startIndex1, setStartIndex1] = useState(0);
    const getPageNumbers1 = () => {
        return Array.from({ length: totalPages1 }, (_, i) => i + 1);
    };

    const handleNext1 = () => {
        if (currentPage1 < totalPages1) {
            setCurrentPage1(currentPage1 + 1);
            if (currentPage1 >= startIndex1 + 4) {
                setStartIndex1(startIndex1 + 4);
            }
        }
    };

    const handlePrevious1 = () => {
        if (currentPage1 > 1) {
            setCurrentPage1(currentPage1 - 1);
            if (currentPage1 - 1 <= startIndex1) {
                setStartIndex1(startIndex1 - 4);
            }
        }
    };

    const [isLoading, setIsLoading] = useState(false)
    const [mainTab, setMainTab] = useState<string | null>(null)
    const [purchaseOrderNumber, setPurchaseOrderNumber] = useState("")
    const [purchaseOrderId, setPurchaseOrderId] = useState("")
    const getPurchaseOrder = () => {
        setIsLoading(true)
        var request: Record<string, any> = {
            what: "getPurchaseOrderForFreightForwarder",
            id: purchaseOrderNumber,
            userId: user?.id
        };
        
        makeGetRequest(request)
            .then((response: any) => {
                setIsLoading(false)
                const res = response.data.data              

                if(res){
                    setRecords(res?.purchaseOrder)
                    setPurchaseOrderId(res.id)
                    getPurchaseOrderItems(res.purchaseOrder.id)

                    dispatch(setPageContext({...pageContext, POFinalShippingAddress: res.finalShippingAddress}))

                }else setRecords(null); setPoLineItems([]); setTotalItems1(0); 
            })
            .catch((error:any) => {
                toast.error(error.msg)
                setIsLoading(false)
            });
    }

    const [purchaseOrderCorrespondingDocuments, setPurchaseOrderCorrespondingDocuments] = useState({
        materialReadinessDocuments: [] as any,
        proofOfCollections: [],
        shippingDocuments: [] as any
    })
    const getPurchaseOrderTrackingInformation = () => {
        setIsLoading(true)
        var request: Record<string, any> = {
            what: "getPurchaseOrderTrackingInformation",
            id: purchaseOrderNumber,
            // params: {
            //     UserId: user?.id
            // }
        };
        
        makeGetRequest(request)
            .then((response: any) => {
                setIsLoading(false)
                const res = response.data.data
                setPurchaseOrderCorrespondingDocuments(res)   
                console.log(res)          
            })
            .catch((error:any) => {
                toast.error(error.msg)
                setIsLoading(false)
            });
    }

    const [searchItem, setSearchItem] = useState("")
    const [filterMaterialNumber, setFilterMaterialNumber] = useState("")
    const getPurchaseOrderItems = (id: string) => {
        setIsLoading(true)
        var request: Record<string, any> = {
            what: "getPurchaseOrderItems",
            id: purchaseOrderNumber,
            params: {
                Page: currentPage1,
                PageSize: itemsPerPage1,     
                PurchaseOrderId: id,  
            }
        };
        if(searchItem) {
            if(!currentPage1) setCurrentPage1(1)
            request.params.SearchString = searchItem
        }
        if(filterMaterialNumber) request.params.MaterialNumber = filterMaterialNumber
        
        makeGetRequest(request)
            .then((response: any) => {
                setIsLoading(false)
                const res = response.data
                setPoLineItems(res.data)
                setTotalItems1(res.totalCount)
                setMainTab(statusBeforeNavigation?.originName ? statusBeforeNavigation?.originName : "items")
            })
            .catch((error:any) => {
                toast.error(error.msg)
                setIsLoading(false)
            });
    }

    useEffect(() => {
        if(purchaseOrderNumber) getPurchaseOrderItems(purchaseOrderId) // eslint-disable-next-line
    }, [searchItem, filterMaterialNumber, itemsPerPage1, currentPage1])

    const handleItemSearch = () => {
        const materialNumber = (document.getElementById("materialnumber") as HTMLInputElement)?.value
        const search = (document.getElementById("searchitem") as HTMLInputElement)?.value
        
        if(search) setSearchItem(search)
        if(materialNumber) setFilterMaterialNumber(materialNumber)
    }

    useEffect(() => {
        if(purchaseOrderNumber) {
            getPurchaseOrder()
            getPurchaseOrderTrackingInformation()
            navigate("/freightforwarder/purchaseorders/"+purchaseOrderNumber)
        } // eslint-disable-next-line
    }, [purchaseOrderNumber, currentPage1, itemsPerPage1])    

    const queryParams = new URLSearchParams(window.location.search); 
    useEffect(() => {
        if(queryParams.get("tab")) setMainTab(queryParams.get("tab"))
        else {
            if(!pageContext || pageContext.tab === undefined) setMainTab(statusBeforeNavigation?.originName ? statusBeforeNavigation?.originName : "items")
            else setMainTab(pageContext.tab)
        }

        if(param.id) setPurchaseOrderNumber(param.id ? param.id : ""); // eslint-disable-next-line
    }, [])

    useEffect(() => {
        if(param.id) {
            const element = (document.getElementById("purchaseOrderNumber") as HTMLInputElement)
            if(element) (document.getElementById("purchaseOrderNumber") as HTMLInputElement).value = param.id
        } // eslint-disable-next-line
    }, [mainTab, document.getElementById("purchaseOrderNumber")])

    const [sortOrder, setSortOrder] = useState<{
        field: string | null;
        ascending: boolean;
    }>({
        field: "purchaseOrderItemNumber",
        ascending: true,
    });

    const handleSort = (field: string) => {
        if (sortOrder.field === field) setSortOrder({ ...sortOrder, ascending: !sortOrder.ascending });
        else setSortOrder({ field, ascending: true });
    };

    const handleCopy = (materialNumber: string) => {
    // Implement the copy logic here
    const tempTextArea = document.createElement("textarea");
    tempTextArea.value = materialNumber;

    // Make the textarea non-editable to avoid focus and activation
    tempTextArea.setAttribute("readonly", "");
    tempTextArea.style.position = "absolute";
    tempTextArea.style.left = "-9999px";

    document.body.appendChild(tempTextArea);
    tempTextArea.select();

    try {
        // Copy the text to the clipboard
        document.execCommand("copy");
        toast.info(`Copied! - ${materialNumber}`)
    } catch (err) {
        toast.error("Unable to copy selected item: " + err);
    } finally {
        document.body.removeChild(tempTextArea);
    }
    };

    const getSuppliedQuantity = (item: any) => {
        return item.reduce((acc: number, item: any) => acc + Number(item.quantity), 0)
    }

    const getStatusColor = (suppliedQty: number, requestedQty: number) => {
        if(suppliedQty === 0) return "yellow"
        if(suppliedQty < requestedQty) return "red"
        if(suppliedQty === requestedQty) return "green"
    }

    const getMaterialReadinessDocumentStatus = (status: string) => {
        switch(status){
            case "NEW_MATERIAL_READINESS_DOCUMENT": return {
                status: "Open",
                color: "#E38600"
            };
            case "PENDING": return {
                status: "Rejected",
                color: "red"
            };
            default: return {
                status: "Closed",
                color: "green"
            };
        }
    }

    const page = "Purchase Orders"

    return (
        <Layout title={page}>
            <div className="container">
                <div className="main">
                    <h3 className="page_title">{  }</h3>   
                    <div className="main-inner">  
                        <div className="detail-top-section">
                            <div className="d-flex-center">
                                {mainTab !== "preview" &&<div style={{display: "flex", padding: "16px"}}>
                                    <div className="search-container">
                                        <span className="material-symbols-rounded">search</span>
                                        <input id="purchaseOrderNumber" placeholder="Search Purchase Orders"/>
                                    </div>
                                    <button className="custom-button orange left-item ml-2"
                                        onClick={() => {setPurchaseOrderNumber((document.getElementById("purchaseOrderNumber") as HTMLInputElement)?.value); setCurrentPage1(1)}}
                                        >Search</button>
                                </div>}                                
                            </div>
                                
                            <div className="tab">                                
                                {mainTab !== "preview" && <>
                                    <div className={mainTab === "items" ? "tab-item active" : "tab-item"}
                                        onClick={() => setMainTab("items")}>
                                        <span className="material-symbols-rounded">format_list_numbered</span>
                                        <p>Purchase Order Items</p>
                                    </div>
                                    <div className={mainTab === "summary" ? "tab-item active" : "tab-item"}
                                        onClick={() => setMainTab("summary")}>
                                        <span className="material-symbols-rounded">contract</span>
                                        <p>Purchase Order Summary</p>
                                    </div> 
                                    {purchaseOrderCorrespondingDocuments?.materialReadinessDocuments?.length > 0 &&
                                        <div className={mainTab === "mrd" ? "tab-item active" : "tab-item"}
                                            onClick={() => setMainTab("mrd")}>
                                            <span className="material-symbols-rounded">note_stack</span>
                                            <p>Material Readiness Documents </p>
                                        </div>
                                    }  
                                    {purchaseOrderCorrespondingDocuments?.proofOfCollections?.length > 0 &&
                                        <div className={mainTab === "poc" ? "tab-item active" : "tab-item"}
                                            onClick={() => setMainTab("poc")}>
                                            <span className="material-symbols-rounded">inventory</span>
                                            <p>Proof of Collections</p>
                                        </div>
                                    } 
                                    {purchaseOrderCorrespondingDocuments?.shippingDocuments?.length > 0 &&
                                        <div className={mainTab === "shipping" ? "tab-item active" : "tab-item"}
                                            onClick={() => setMainTab("shipping")}>
                                            <span className="material-symbols-rounded">inventory</span>
                                            <p>Shipping Documents</p>
                                        </div>                                
                                    }      
                                </> }                                    
                            </div>                          
                        </div> 
                    </div> 

                    {!purchaseOrder && <div className="main-inner" style={{minHeight: "calc(100vh - 160px)"}}>
                        <p style={{fontSize: "12px", padding: "24px", color: "#929292"}}>
                            {purchaseOrderNumber && !isLoading ? `No Records Found with Purchase Order Number ${purchaseOrderNumber}` : "Search Purchase Order Number to Filter Items"}
                        </p>
                    </div>}

                    {purchaseOrder && <div className="main-inner mt-1" style={{minHeight: "calc(100vh - 160px)"}}>                  
                        {mainTab === "summary" && <div className="form-view-container">
                                <div className='d-grid' style={{gap: "18px"}}>                                    
                                <div className='form-item'>
                                    <label>Purchase Order Number</label>
                                        <input type='text' disabled value={purchaseOrder?.purchaseOrderNumber} />
                                    </div>   
                                    <div className='form-item'>
                                        <label>Date</label>
                                        <input type='text' disabled value={formatDateTime(purchaseOrder ? purchaseOrder?.createdDate : "")} />
                                    </div> 
                                    <div className='form-item span-col-2'>
                                        <label>Supplier Address</label>
                                        <input type='text' disabled value={purchaseOrder?.supplierAddress} />
                                    </div>  
                                    <div className='form-item'>
                                        <label>Supplier</label>
                                        <input type='text' disabled value={purchaseOrder?.supplierName} />
                                    </div> 
                                    <div className='form-item'>
                                        <label>Supplier Phone Number</label>
                                        <input type='text' disabled value={purchaseOrder?.supplierPhoneNumber} />
                                    </div>                                                                               
                                    
                                    <div className='form-item'>
                                        <label>Buyer Name</label>
                                        <input type='text' disabled value={purchaseOrder?.buyerName} />
                                    </div>
                                    <div className='form-item span-col-2'>
                                        <label>Buyer Email</label>
                                        <input type='text' disabled value={purchaseOrder?.buyerEmail} />
                                    </div>
                                    <div className='form-item span-col-2'>
                                        <label>Final Shipping Address</label>
                                        <input type='text' disabled value={purchaseOrder?.finalShippingAddress}/>
                                    </div>
                                    <div className='form-item'>
                                        <label>Incoterms</label>
                                        <input type='text' disabled value={purchaseOrder?.incoterms}/>
                                    </div>                                   
                                    <div className='form-item'>
                                        <label>Total amount w/o taxes</label>
                                        <input type='text' disabled value={`${getCurrencySymbol(poLineItems ? poLineItems[0]?.currency : "")}${formatCurrency(purchaseOrder?.totalAmountTaxes)}`} />
                                    </div>  
                                    <div className='form-item'>
                                        <label>Total Net Amount of Order</label>
                                        <input type='text' disabled value={`${getCurrencySymbol(poLineItems ? poLineItems[0]?.currency : "")}${formatCurrency(purchaseOrder?.totalNetAmountOfOrder)}`} />
                                    </div>
                                    <div className='form-item'>
                                        <label>Total Amount of Order</label>
                                        <input type='text' disabled value={`${getCurrencySymbol(poLineItems ? poLineItems[0]?.currency : "")}${formatCurrency(purchaseOrder?.totalAmountOfOrder)}`} />
                                    </div>         
                                </div>
                        </div>} 
                        {mainTab === "items" && <div style={{minHeight: "400px"}}>
                            <div className="inside d-flex">
                                <div className="card">
                                    <img src={number} alt="" width="40px" height="40px" />
                                    <div>
                                        <p>Purchase Order Number</p>
                                        <span>{purchaseOrder?.purchaseOrderNumber}</span>
                                    </div>
                                </div>
                                <div className="card">
                                    <img src={date} alt="" width="40px" height="40px" />
                                    <div>
                                        <p>Date</p>
                                        <span>{formatDateTime(purchaseOrder ? purchaseOrder?.createdDate : "")}</span>
                                    </div>
                                </div>
                                <div className="card">
                                    <img src={status} alt="" width="40px" height="40px" />
                                    <div>
                                        <p>Total Order Amount</p>
                                        <span>{getCurrencySymbol(poLineItems ? poLineItems[0]?.currency : "")}{formatCurrency(purchaseOrder?.totalAmountOfOrder)}</span>
                                        {/* <span>{formatCurrency(purchaseOrder?.totalAmountOfOrder)}</span> */}
                                    </div>
                                </div> 
                                <div className="card">
                                    <img src={person} alt="" width="36px" height="36px" />
                                    <div>
                                        <p>Final Shipping Address</p>
                                        <span>{purchaseOrder?.finalShippingAddress}</span>
                                    </div>
                                </div>                                   
                            </div>
                            <div className='table-container custom mt-2' style={{minHeight: "750px"}}>
                                <div className="filter-container">
                                    <div className="search-container">
                                        <span className="material-symbols-rounded" style={{fontSize: "16px"}}>search</span>
                                        <input id="searchitem" placeholder="Search" onChange={(e) => {if(e.target.value.length < 1) setSearchItem("")}}/>
                                    </div>
                                    {/* <select id="itemstatus">
                                        {
                                            POItemSupplyStatus().map((status: StatusProp, index: number) => (
                                                <option key={index} value={status.value}>
                                                  {status.name}
                                                </option>
                                            ))
                                        }
                                    </select> */}
                                    <div className="custom-button orange" style={{height: "18px"}} onClick={() => handleItemSearch()}>Search</div>
                                    {/* <div className={(!searchItem && !filterMaterialNumber) ? "actions blue disabled" : "actions blue"} onClick={() => clearFilters()}>
                                        <span className="material-symbols-rounded">filter_alt_off</span>
                                        Clear Filters</div> */}
                                </div>
                                <table>
                                    <thead>
                                        <tr className="no-textwrap">
                                            <th>
                                                <div className="sort" onClick={() => handleSort('purchaseOrderItemNumber')}>
                                                <span className="material-symbols-rounded">unfold_more</span>
                                                    Item No
                                                </div>
                                            </th>
                                            <th>
                                                <div className="sort" onClick={() => handleSort('materialNumber')}>
                                                    <span className="material-symbols-rounded">unfold_more</span>
                                                    Material Number
                                                </div>
                                            </th>
                                            <th>Material Description</th>
                                            <th>Delivery Date</th>
                                            <th>Quantity</th>
                                            <th>Unit</th>
                                            <th>Unit Price ({poLineItems ? poLineItems[0]?.currency : ""})</th>
                                            <th>Net Amount ({poLineItems ? poLineItems[0]?.currency : ""})</th>
                                            <th>Shipment Mode</th>
                                            <th>Manufacturer Part No</th>
                                            <th>Manufacturer</th>
                                            <th style={{ position: "sticky", right: '0', zIndex: '1'}}>Supplied Qty</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            poLineItems?.map((data, i) => {
                                                return (
                                                    <tr key={i}>
                                                        <td style={{paddingLeft: "40px"}}>Item { data.purchaseOrderItemNumber }</td>
                                                        <td>
                                                            <span title="Copy Material Number"
                                                                onClick={() => handleCopy(data.materialNumber)} 
                                                                className="material-symbols-outlined mr-2" 
                                                                style={{fontSize: "16px", cursor: "pointer"}}>content_copy
                                                            </span>{ data.materialNumber }
                                                        </td>
                                                        <td>{ data.materialDescription }</td>
                                                        <td className="no-textwrap">{  formatDateTime(data.deliveryDate) }</td>
                                                        <td>{ data.quantity }</td>
                                                        <td>{ data.unit }</td>                                                    
                                                        <td>{ formatCurrency(data.unitPrice) }</td>
                                                        <td>{ formatCurrency(data.netAmount) }</td>
                                                        {data.modeOfTransportation==="SEA" && <td>
                                                            <span className="material-symbols-rounded" style={{marginRight:"8px", marginTop: "-10px", fontSize: "18px"}}>sailing</span>
                                                            <span>Sea</span>
                                                            </td>}
                                                        {data.modeOfTransportation==="AIR" && <td>
                                                            <span className="material-symbols-rounded" style={{marginRight:"8px", marginTop: "-10px", fontSize: "18px"}}>flight</span>
                                                            <span>Air</span>
                                                            </td>}
                                                        <td>{ data.manufacturerPartNumber }</td>
                                                        <td className="no-textwrap ">{ data.manufacturer }</td>
                                                        {/* <td className="status pending">{getStatus(data.status)}</td> */}
                                                        <td style={{ position: "sticky", textAlign: "center", right: '0'}} 
                                                            className={`status ${getStatusColor(getSuppliedQuantity(data.purchaseOrderItemSupplies), Number(data.quantity))}`}>
                                                            <strong>{ getSuppliedQuantity(data.purchaseOrderItemSupplies) } / {data.quantity}</strong>
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>                          
                            </div>
                            <div className="pagination-container">
                            <Pagination
                                currentPage={currentPage1}
                                itemsPerPage={itemsPerPage1}
                                totalPages={totalPages1}
                                handlePrevious={handlePrevious1}
                                handleNext={handleNext1}
                                setCurrentPage={setCurrentPage1}
                                getPageNumbers={getPageNumbers1}
                                setItemsPerPage={setItemsPerPage1}
                                startIndex={startIndex1} />
                            </div> 
                        </div> }
                        {mainTab === "mrd" && <div style={{minHeight: "calc(100vh - 160px)"}}>
                            <div className='table-container custom'>
                                <table>
                                    <thead>
                                        <tr className="no-textwrap">
                                            <th style={{padding: "16px"}}>SN</th>
                                            <th>MRD Number</th>
                                            <th>Issuance Date</th>
                                            <th>Pickup Country</th>
                                            <th>Delivery Destination</th>
                                            <th>Currency</th>
                                            <th>Status</th>
                                            <th style={{width: "120px"}}>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        purchaseOrderCorrespondingDocuments?.materialReadinessDocuments?.map((data: any, index: number) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td>{ index + 1 }</td>
                                                            <td className="no-textwrap">{ data.mrdNumber }</td>
                                                            <td>{ formatDateTime(data.createdDate) }</td>
                                                            <td>{ data.countryOfSupply }</td>
                                                            <td>{ data.destination }</td>
                                                            <td>{ data.currency }</td>
                                                            <td style={{color: getMaterialReadinessDocumentStatus(data?.materialReadinessDocumentStatus).color}}
                                                            >{ getMaterialReadinessDocumentStatus(data?.materialReadinessDocumentStatus).status }</td>
                                                            <td className="actions">
                                                                <button onClick={() => 
                                                                    {navigate("/freightforwarder/materialreadinessdocument/"+data.id, {state: 
                                                                        {status: status, origin: "/freightforwarder/purchaseorders/"+purchaseOrderNumber, pageNumber: 1}})
                                                                        // dispatch(setPageContext({...pageContext, url: "/freightforwarder/purchaseorders/"+purchaseOrderNumber
                                                                        
                                                                    }} className="actions">
                                                                    <span className="material-symbols-rounded">pageview</span>
                                                                    <span>View Details</span>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                    }
                                    </tbody>
                                </table>
                            </div>
                        </div>}
                        {mainTab === "poc" && <div style={{minHeight: "calc(100vh - 160px)"}}>
                            <div className='table-container custom'>
                                <table>
                                    <thead>
                                        <tr className="no-textwrap">
                                            <th>SN</th>
                                            <th>POC Number</th>
                                            <th>Date Created</th>
                                            <th>Pick Up Date</th>
                                            <th>MRD Number</th>
                                            <th>Freight Forwarder</th>
                                            {/* <th>Supplier Acknowledged</th> */}
                                            <th style={{width: "110px"}}>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            purchaseOrderCorrespondingDocuments?.proofOfCollections
                                            ?.filter((data: any) => data !== null)
                                            .map((data: any, index: number) => {
                                                return (
                                                    <tr key={index}>
                                                        <td>{ index + 1 }</td>
                                                        <td>{ data?.pocNumber }</td>
                                                        <td>{ formatDateTime(data?.createdDate) }</td>
                                                        <td>{ formatDateTime(data?.pickUpDate).substring(0, 10) }</td>
                                                        <td>{ data?.materialReadinessDocuments ? data?.materialReadinessDocuments[0]?.mrdNumber : null  }</td>
                                                        <td>{ data?.freightForwarderCompanyName  }</td><td>
                                                            <button onClick={() => {navigate("/freightforwarder/proofofcollection/"+data.id); 
                                                                dispatch(setPageContext({...pageContext, url: "/freightforwarder/purchaseorders/"+purchaseOrderNumber}))}} 
                                                                className="actions">
                                                                <span className="material-symbols-rounded">pageview</span>
                                                                <span>View Details</span>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>}
                        {mainTab === "shipping" && <div style={{minHeight: "calc(100vh - 160px)"}}>
                            <div className='table-container custom'>
                                <table>
                                    <thead>
                                        <tr className="no-textwrap">
                                            <th style={{padding: "16px"}}>SN</th>
                                            <th>BL/AWB Number</th>
                                            <th>Shipment Number</th>
                                            {/* <th>Shipping Mode</th>
                                            <th>Currency</th>
                                            <th>Destination</th> */}
                                            <th title='Estimated Time of Departure'>ETD</th>
                                            <th title='Estimated Time of Arrival'>ETA</th>
                                            <th title='Actual Time of Arrival'>ATA</th>
                                            <th>Shipment Confirmed</th>
                                            <th style={{width: "116px"}}>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            purchaseOrderCorrespondingDocuments?.shippingDocuments
                                            ?.map((data: any, index: number) => {
                                                return (
                                                    <tr key={index}>
                                                    <td>{ index + 1 }</td>
                                                    <td>{ data.referenceNumber ?? "N/A" }</td>
                                                    <td>{ data.shippingNumber }</td>
                                                    {/* <td>{ data.consolidatedPackingList?.modeOfShipping }</td>
                                                    <td>{ data?.consolidatedCommercialInvoice?.purchaseOrderItemSupplies[0]?.currency }</td>
                                                    <td>{ data.consolidatedPackingList?.destination }</td> */}
                                                    <td>
                                                        <span>{formatDateTime(data.estimatedTimeOfDeparture).substring(0, 10)}</span>
                                                    </td>
                                                    <td>
                                                        <span>{formatDateTime(data.estimatedTimeOfArrival).substring(0, 10)}</span>      
                                                    </td>  
                                                    <td>
                                                        <span>{formatDateTime(data.actualTimeOfArrival).substring(0, 10)}</span>
                                                    </td>
                                                    <td>
                                                        {(data?.vesselName && data?.containerDescription) && 
                                                        <div className='d-flex-2'>
                                                            <span className="material-symbols-rounded text-green fw-500" style={{fontSize: "16px"}}>check</span>
                                                            <span>Shipped</span>
                                                        </div>
                                                        }
                                                        {!(data?.vesselName && data?.containerDescription) && 
                                                        <div className='d-flex-2'>
                                                            <span className="material-symbols-rounded text-yellow fw-600" style={{fontSize: "16px"}} >hourglass_top</span>
                                                            <span>Awaiting Shipment</span>
                                                        </div>
                                                        }
                                                    </td>
                                                    <td>
                                                        <button onClick={() => 
                                                            {navigate("/freightforwarder/shippingdocuments/"+data.id, 
                                                                {state: {status: status, origin: "/freightforwarder/purchaseorders/"+purchaseOrderNumber}});
                                                                dispatch(setPageContext({...pageContext, url: "/freightforwarder/purchaseorders/"+purchaseOrderNumber}));
                                                        }} className="actions">
                                                            <span className="material-symbols-rounded">pageview</span>
                                                            <span>View Details</span>
                                                        </button>
                                                    </td>
                                                </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                                {isLoading ? <div className="loader">
                                            <img src={loading} alt="loading" />
                                            <p>Loading data...</p>
                                        </div> : null}
                            </div>
                        </div>}
                    </div> }                                     
                </div>
                <Modal isOpen={isLoading} style={customStyles} className="modal modal-sm" ariaHideApp={false}>
                    <div className="loader">
                        <img src={loading} alt="loading" />
                        <p>Loading data...</p>
                    </div>
                </Modal> 

                {/* <Modal isOpen={openFeedbackModal} style={customStyles} className="modal modal-3" ariaHideApp={false}>
                    <div className="modal-header">
                        <h3>Feedback</h3>
                        <span className="material-symbols-rounded close"
                            onClick={() => setOpenFeedbackModal(false)}>close</span>
                    </div>
                    <div className="modal-body" style={{height: "120px", overflowY: "auto"}}>
                        <p style={{margin: 0}}>{feedback}</p>
                    </div>
                </Modal> */}

                {/* <Modal isOpen={openClaimModal} style={customStyles} className="modal modal-3" ariaHideApp={false}>
                    <div className="modal-header">
                        <h3 style={{display: "flex", alignItems: "center", gap: "6px"}}>Discrepancy</h3>
                        <span className="material-symbols-rounded close"
                            onClick={() => setOpenClaimModal(false)}>close</span>
                    </div>
                    <div className="modal-body" style={{minHeight: "120px", fontSize: "12px"}}>
                        {claim}
                    </div>
                </Modal> */}
                <ToastContainer />
            </div>
        </Layout>
    )
}

export default PurchaseOrder